var map = {
	"./404.svg": 942,
	"./Categories.png": 943,
	"./Edit-menu.svg": 944,
	"./Egg.svg": 945,
	"./Emaier-Header.png": 946,
	"./Qr-4.png": 947,
	"./_duplicate.svg": 948,
	"./_overview.svg": 949,
	"./add-white.svg": 950,
	"./alert.svg": 951,
	"./all_category.svg": 952,
	"./archive.svg": 953,
	"./armchair.svg": 954,
	"./arrow-circle-right.svg": 955,
	"./arrow-left-circle.svg": 956,
	"./arrow-right-circle.svg": 957,
	"./arrow-right.svg": 355,
	"./asc-up-white.svg": 958,
	"./asc.png": 959,
	"./asc.svg": 960,
	"./back-arrow.svg": 961,
	"./barcode-icon.svg": 962,
	"./beverages.svg": 963,
	"./blue-edit-pen.svg": 964,
	"./blue-eye.svg": 965,
	"./box-office.svg": 966,
	"./broken-seat.jpg": 967,
	"./calendar_list.svg": 968,
	"./chevron-down.svg": 969,
	"./chevron-left.svg": 970,
	"./cinema-mamagement-sidebar.svg": 971,
	"./claendar.svg": 305,
	"./clock-1.svg": 972,
	"./clock.svg": 973,
	"./close-button.svg": 702,
	"./close-white.svg": 705,
	"./close-x.svg": 300,
	"./collapse-up.svg": 974,
	"./collapse.svg": 975,
	"./connection-lost.svg": 353,
	"./copy.svg": 976,
	"./copy_image_icon.png": 977,
	"./delete-red-light.svg": 978,
	"./delete-red.svg": 711,
	"./delete.svg": 688,
	"./deliver-icon.svg": 979,
	"./desc-down-white.svg": 980,
	"./desc.svg": 981,
	"./distributors-sidebar.svg": 982,
	"./download.svg": 983,
	"./dragndrop.svg": 984,
	"./dragndrop2.svg": 985,
	"./duplicate.svg": 986,
	"./duplicateScreen.svg": 987,
	"./e-wallet-icon-black.svg": 988,
	"./edit-pen-blue.svg": 989,
	"./edit-pen-white.svg": 990,
	"./edit-pen.svg": 991,
	"./edit.svg": 992,
	"./email.png": 993,
	"./empty-image.svg": 994,
	"./excel.svg": 995,
	"./external-link.svg": 996,
	"./eye.svg": 997,
	"./filter-icon.svg": 998,
	"./flag.svg": 999,
	"./fnb-app-order.svg": 1000,
	"./fnb-beverages.svg": 1001,
	"./fnb-brownie.svg": 1002,
	"./fnb-combo.svg": 1003,
	"./fnb-desert.svg": 1004,
	"./fnb-eatables.svg": 1005,
	"./fnb-make-your-combo.svg": 1006,
	"./fnb-popcorn.svg": 1007,
	"./fnbtransactionIcon.svg": 1008,
	"./fullscreen-icon.svg": 712,
	"./funnel.svg": 1009,
	"./globe.svg": 1010,
	"./green-tick.svg": 1011,
	"./grid-view.svg": 1012,
	"./hide-password.svg": 356,
	"./home-icon.svg": 1013,
	"./home.svg": 1014,
	"./icon-black-play.svg": 1015,
	"./icon-dot.svg": 1016,
	"./icon-fnb.svg": 1017,
	"./icon-marketing.svg": 1018,
	"./icon-no-seat.png": 1019,
	"./icon-no-seat.svg": 1020,
	"./icon-option.svg": 1021,
	"./icon-poin-of-sale.svg": 1022,
	"./icon-recliner.svg": 1023,
	"./icon-report.svg": 1024,
	"./icon-sofa-dark-1.svg": 1025,
	"./icon-sofa-dark.png": 1026,
	"./icon-sofa-dark.svg": 1027,
	"./icon-sofa.svg": 1028,
	"./importfile.svg": 1029,
	"./info.svg": 706,
	"./info2.svg": 1030,
	"./keyboard-icon.svg": 1031,
	"./kitchen_display.svg": 1032,
	"./language-icon.svg": 301,
	"./left-caret.svg": 1033,
	"./link.svg": 1034,
	"./list-view.svg": 1035,
	"./loading.svg": 357,
	"./lock.svg": 1036,
	"./login-password.png": 358,
	"./login-user.png": 359,
	"./logout.svg": 707,
	"./masters-sidebar.svg": 1037,
	"./merchandise.svg": 1038,
	"./minus.svg": 1039,
	"./movie-pass-svg.svg": 694,
	"./movie-rolling.svg": 1040,
	"./mulitSchedule.svg": 1041,
	"./multicurrency.svg": 1042,
	"./multifnb.svg": 1043,
	"./nav-plus.svg": 1044,
	"./new_filter_icon.svg": 1045,
	"./no-image.svg": 1046,
	"./no-schedule.svg": 134,
	"./non-veg-mark.png": 1047,
	"./non-veg-mark.svg": 1048,
	"./notification.svg": 1049,
	"./open-link-blue.svg": 1050,
	"./openPlanned.svg": 1051,
	"./overview.svg": 1052,
	"./overview2.svg": 1053,
	"./pdf-icon.svg": 1054,
	"./pdf.svg": 1055,
	"./pickup-ticket-icon.svg": 1056,
	"./pickupfnb.svg": 1057,
	"./play.svg": 1058,
	"./plus.svg": 1059,
	"./pointofsale-1.svg": 1060,
	"./pointofsale-2.svg": 1061,
	"./pointofsale.png": 1062,
	"./portfolio.svg": 1063,
	"./pos-fnb-no-itmes.svg": 699,
	"./pos-refresh.svg": 1064,
	"./primary/chevron-down.svg": 1065,
	"./primary/download.svg": 1066,
	"./primary/edit.svg": 1067,
	"./primary/filter.svg": 1068,
	"./primary/printer.svg": 1069,
	"./print-icon.svg": 1070,
	"./print.svg": 1071,
	"./question.svg": 1072,
	"./question1.svg": 1073,
	"./question2.svg": 713,
	"./question3.svg": 1074,
	"./recliner-1.svg": 1075,
	"./recliner.png": 1076,
	"./refund-icon.svg": 1077,
	"./reload-icon-pos.svg": 1078,
	"./reload-icon.svg": 1079,
	"./restore.svg": 1080,
	"./right-caret.svg": 1081,
	"./role-management-sidebar.svg": 1082,
	"./save.svg": 1083,
	"./schedule-icon.svg": 1084,
	"./school-calendar.svg": 1085,
	"./search-global-white.svg": 1086,
	"./search-global.svg": 1087,
	"./search.svg": 714,
	"./searchIcon.svg": 1088,
	"./seat-icon-2.svg": 1089,
	"./seat-icon.svg": 1090,
	"./seat-icons/3-wheelChair.png": 1091,
	"./seat-icons/block_seat_new.png": 1092,
	"./seat-icons/broken-seat-1.svg": 1093,
	"./seat-icons/broken-seat-2.svg": 1094,
	"./select-food.png": 715,
	"./settings.svg": 1095,
	"./show-password.svg": 360,
	"./slider-triangle.svg": 1096,
	"./snack.svg": 708,
	"./sort.svg": 1097,
	"./star-empty.svg": 1098,
	"./star-fill.svg": 1099,
	"./success-tick.svg": 1100,
	"./suitcase.svg": 1101,
	"./swap.svg": 1102,
	"./tick-green-item.svg": 716,
	"./tick-green.svg": 1103,
	"./ticket-icon.svg": 1104,
	"./trash.svg": 1105,
	"./unpaid-reservation.svg": 691,
	"./updown-white.svg": 1106,
	"./updown.svg": 1107,
	"./user-attribute.svg": 1108,
	"./user-attributes.svg": 1109,
	"./user-female.svg": 1110,
	"./user-male-white.svg": 1111,
	"./user-male.svg": 1112,
	"./user-profile.svg": 1113,
	"./userProfile.png": 1114,
	"./veg-food-mark-white.png": 1115,
	"./veg-foog-mark-trans.png": 1116,
	"./view.png": 1117,
	"./view.svg": 1118
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 941;


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons ^\.\/.*$
// module id = 941
// module chunks = 34